/**
 * bookCovers — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {PORTRAIT, tagline, chips, type ToilePack} from './data'

export const bookCoversPack: ToilePack = {
    slug: 'book-covers',
    category: 'bookcover',
    name: 'Book covers',
    tagline: tagline('covers', 'genres', 'styles'),
    chips: chips('genres', 'styles'),
    ratio: PORTRAIT,
    readings: [
        {key: 'thriller', label: 'The Quiet Line', subject: 'a thriller, a lone silhouette on a night platform, rails into fog'},
        {key: 'romance', label: 'Salt and Honey', subject: 'a romance, two deck chairs on a sunlit balcony above a blue coast'},
        {key: 'fantasy', label: 'The Ember Crown', subject: 'an epic fantasy, a cracked iron crown wreathed in embers'},
    ],
    styles: [
        {key: 'type', label: 'Typographic', style: 'typographic, expressive title type', palette: 'two-color, one flat geometric motif', framing: 'front cover flat, author line small'},
        {key: 'illustrated', label: 'Illustrated', style: 'illustrated, a painted scene, hand-lettered title', palette: 'rich layered color', framing: 'front cover flat, author line small'},
        {key: 'photo', label: 'Photographic', style: 'moody photographic, one strong image', palette: 'muted grade, deep shadow', framing: 'front cover flat, author line small'},
    ],
    directions: ['a sci-fi novel instead', 'in black and acid yellow', 'darker and more foreboding'],
}
